<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="py-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div v-if="getUserDetail()">
          <b-avatar
            variant="primary"
            id="avatarUser"
            :text="getUserDetail().firstname.charAt(0)"
          ></b-avatar>
        </div>
        <div v-if="!getUserDetail()">
          <b-avatar variant="primary" id="avatarUser" text="A"></b-avatar>
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownItem @click="handleLogout">
      <CIcon name="cil-lock-locked" class="my-2" />Logout
    </CDropdownItem>
    <b-modal
      ref="logOutModal"
      id="logOutModal"
      centered
      hide-header
      hide-footer
    >
      <div class="modal-header">
        <h4>ออกจากระบบ</h4>
        <button
          type="button"
          aria-label="Close"
          class="close"
          @click="$bvModal.hide('logOutModal')"
        >
          ×
        </button>
      </div>
      <div class="text-center px-md-5 py-4">
        <p class="text-text font-weight-bold">
          คุณแน่ใจหรือไม่ว่าคุณต้องการออกจากระบบ?
        </p>
      </div>
      <div class="form-inline justify-content-center mt-2">
        <b-button
          class="mr-2 btn-modal"
          variant="secondary"
          @click="$bvModal.hide('logOutModal')"
          >ไม่</b-button
        >
        <b-button
          class="ml-2 btn-modal-submit"
          variant="primary"
          @click="logout"
          >ใช่</b-button
        >
      </div>
    </b-modal>

    <b-modal
      ref="alertModal"
      id="alertModal"
      hide-header
      hide-footer
      centered
      size="sm"
      no-close-on-backdrop
    >
      <div class="text-center">
        <img
          src="@/assets/images/icons/loading.svg"
          alt="loading"
          class="mb-3 img"
        />
        <p class="text-text font-weight-bold">กรุณารอสักครู่...</p>
      </div>
    </b-modal>
  </CDropdown>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TheHeaderDropdownAccnt",
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getUserDetail"])
  },
  methods: {
    handleLogout() {
      this.$refs.logOutModal.show();
    },
    logout: async function() {
      this.$refs.logOutModal.hide();
      this.$refs.alertModal.show();
      this.$cookies.remove("admin-token");
      window.location.href = "/";
    }
  }
};
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
#avatarUser {
  background-color: #b07ec9;
  color: #8f20c6;
}
::v-deep .lang-dd button {
  background-color: transparent;
  border: none;
  padding: 0;
}

::v-deep .lang-dd button:focus,
::v-deep .lang-dd button:active,
::v-deep .lang-dd.show > .btn-secondary.dropdown-toggle,
::v-deep .lang-dd button:hover {
  background-color: transparent !important;
  border: none;
  padding: 0;
}

.lang-dd {
  border: 1px solid #dcdcdc;
  padding: 5px 10px;
}

::v-deep .lang-dd ul {
  width: 100px;
}

.modal-header {
  border-bottom: 0 !important;
  margin: 0px;
  padding: 0px;
  padding-bottom: 0.25rem;
}

.text-msg {
  font-size: 2rem;
  color: #4a4a4a;
}

.btn-modal {
  width: 100px;
  font-weight: bold;
}

.btn-modal-submit {
  width: 100px;
  font-weight: bold;
  background-color: #8f20c6 !important;
  border-color: #8f20c6;
}

.text-text {
  color: #4a4a4a;
  margin-bottom: 0;
  font-size: 1.2rem;
}

.img {
  width: 100px;
}
</style>
